/* Duskhaven homepage product cards: prev/next image arrows and a quick view dialog.
 * Image 2 on hover is pure CSS (dh-card-gallery.css); this file adds stepping and quick view.
 * Cards ship with only their first image; the rest of each gallery waits in a <template> until
 * hover, focus, touch, swipe or an arrow press (hydrate below). */
(function () {
  if (window.__dhCardGallery) return;
  window.__dhCardGallery = true;

  var ICON_PREV = '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" focusable="false"><path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="m15 6-6 6 6 6"/></svg>';
  var ICON_NEXT = '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" focusable="false"><path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="m9 6 6 6-6 6"/></svg>';
  var ICON_PLUG = '<svg viewBox="0 0 24 24" width="15" height="15" aria-hidden="true" focusable="false" style="flex:0 0 auto;margin-top:2px;color:var(--dh-gold,#d4aa61)"><g fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M9 2v6M15 2v6"/><path d="M6 8h12v3a6 6 0 0 1-12 0z"/><path d="M12 17v5"/></g></svg>';
  var canHover = window.matchMedia('(hover: hover)');

  /* ---------- Card galleries ---------- */

  function loadSlide(img) {
    var src = img.getAttribute('data-dh-src');
    if (src) { img.src = src; img.removeAttribute('data-dh-src'); }
  }

  // Cards ship with only their first image. The rest of the gallery waits in a <template>
  // until the shopper shows interest (hover, focus, touch, swipe or an arrow press).
  function hydrate(media) {
    var tpl = media.querySelector('template[data-dh-card-rest]');
    if (!tpl) return;
    var link = media.querySelector('.dh-card-image');
    if (!link) return;
    link.appendChild(tpl.content.cloneNode(true));
    tpl.remove();
    var slides = link.querySelectorAll('.dh-card-slide');
    if (slides.length < 2) return;
    media.setAttribute('data-dh-has-alt', '');
    // Only swap to image 2 on hover once it has actually arrived, so the frame never flashes empty.
    var alt = slides[1];
    loadSlide(alt);
    var ready = function () { media.classList.add('is-alt-ready'); };
    if (alt.complete && alt.naturalWidth) ready();
    else alt.addEventListener('load', ready, { once: true });
  }

  function visibleIndex(media) {
    var card = media.closest('.dh-card');
    if (!media.classList.contains('is-nav') && media.hasAttribute('data-dh-has-alt') &&
        media.classList.contains('is-alt-ready') && canHover.matches && card && card.matches(':hover')) return 1;
    return media.__dhIndex || 0;
  }

  function showSlide(media, index) {
    var slides = media.querySelectorAll('.dh-card-slide');
    if (!slides.length) return;
    index = (index + slides.length) % slides.length;
    slides.forEach(function (img, i) {
      if (i === index || i === (index + 1) % slides.length) loadSlide(img);
      img.classList.toggle('is-active', i === index);
    });
    media.__dhIndex = index;
  }

  function stepMedia(media, delta) {
    hydrate(media);
    var current = visibleIndex(media);
    media.classList.add('is-nav');
    showSlide(media, current + delta);
  }

  function step(button, delta) {
    var media = button.closest('[data-dh-card-media]');
    if (media) stepMedia(media, delta);
  }

  // Touch: a sideways swipe anywhere on the card flips through its photos (grid cards only;
  // rail cards scroll the rail instead). Works on lazy cards: the first touch brings in the
  // rest of the gallery, and the swipe then steps through it.
  var SWIPE_MIN = 30;
  function bindSwipe(card, media) {
    if (card.closest('[data-dh-rail]')) return;
    if (!media.hasAttribute('data-dh-has-alt') && !media.hasAttribute('data-dh-rest')) return;
    var start = null;
    card.addEventListener('touchstart', function (event) {
      if (event.touches.length !== 1 || (event.target instanceof Element && event.target.closest('button'))) { start = null; return; }
      start = { x: event.touches[0].clientX, y: event.touches[0].clientY };
      hydrate(media);
    }, { passive: true });
    card.addEventListener('touchend', function (event) {
      if (!start) return;
      var touch = event.changedTouches[0];
      var dx = touch.clientX - start.x;
      var dy = touch.clientY - start.y;
      start = null;
      if (Math.abs(dx) < SWIPE_MIN || Math.abs(dx) < Math.abs(dy) * 1.2) return;
      stepMedia(media, dx < 0 ? 1 : -1);
      card.__dhSwipedAt = Date.now();
    }, { passive: true });
    card.addEventListener('touchcancel', function () { start = null; }, { passive: true });
    // A swipe must not also open the product page.
    card.addEventListener('click', function (event) {
      if (card.__dhSwipedAt && Date.now() - card.__dhSwipedAt < 500) {
        event.preventDefault();
        event.stopPropagation();
      }
    }, true);
  }

  function wake(media) {
    hydrate(media);
    var third = media.querySelectorAll('.dh-card-slide')[2];
    if (third) loadSlide(third);
  }

  function bindCards(root) {
    (root || document).querySelectorAll('[data-dh-card-media]').forEach(function (media) {
      var card = media.closest('.dh-card');
      if (!card || card.__dhBound) return;
      card.__dhBound = true;
      bindSwipe(card, media);
      // First sign of interest: bring in the rest of the gallery (only image 2 downloads now),
      // then have image 3 ready for the first arrow click.
      card.addEventListener('pointerenter', function () { wake(media); }, { once: true });
      card.addEventListener('focusin', function () { wake(media); }, { once: true });
      media.addEventListener('touchstart', function () { hydrate(media); }, { once: true, passive: true });
      // Leaving the card puts it back on its first image, ready for the next hover.
      card.addEventListener('pointerleave', function (event) {
        if (event.pointerType !== 'mouse') return;
        media.classList.remove('is-nav');
        showSlide(media, 0);
      });
      // Warm the product data so quick view opens instantly.
      var quick = card.querySelector('[data-dh-quick-view]');
      if (quick) quick.addEventListener('pointerenter', function () { getProduct(quick.getAttribute('data-dh-quick-view')).catch(function () {}); }, { once: true });
    });
  }

  /* ---------- Money ---------- */

  function formatMoney(cents) {
    var holder = document.querySelector('[data-dh-money-format]');
    var format = (holder && holder.getAttribute('data-dh-money-format')) || '${{amount}}';
    var value = Number(cents) / 100;
    function group(decimals, thousands, decimal) {
      var parts = value.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (match, key) {
      var out;
      if (key === 'amount_no_decimals') out = group(0, ',', '.');
      else if (key === 'amount_with_comma_separator') out = group(2, '.', ',');
      else if (key === 'amount_no_decimals_with_comma_separator') out = group(0, '.', ',');
      else if (key === 'amount_with_apostrophe_separator') out = group(2, "'", '.');
      else out = group(2, ',', '.');
      // Match the cards, which use money_without_trailing_zeros.
      return out.replace(/[.,]00$/, '');
    });
  }

  /* ---------- Quick view ---------- */

  var productCache = {};
  var eventsModule = null;
  var dialog = null;
  var state = null;

  function rootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function getProduct(url) {
    var clean = url.split('?')[0].split('#')[0];
    if (!productCache[clean]) {
      productCache[clean] = fetch(clean + '.js', { headers: { Accept: 'application/json' } })
        .then(function (response) {
          if (!response.ok) throw new Error('Product request failed: ' + response.status);
          return response.json();
        })
        .catch(function (error) { delete productCache[clean]; throw error; });
    }
    return productCache[clean];
  }

  function sized(src, width) {
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  function stripQuery(src) { return String(src || '').split('?')[0].replace(/^https?:/, ''); }

  // 2026-10-02 (Todd): the name-and-symbol photo (slot 2 of every product) is shown only in "Why you'll love it" on the
  // product page, not in the quick view, because the name and symbol already sit above the title. It is found by its alt
  // text ("Fenn – name symbol") or file name ("02-fenn-name-symbol"). Same rule as snippets/dh-product-card.liquid.
  function quickViewImages(product) {
    var skip = {};
    (product.media || []).forEach(function (m) {
      if (m.media_type === 'image' && /name[-_ ]?symbol|name and symbol/i.test(String(m.src || '') + ' ' + String(m.alt || ''))) skip[stripQuery(m.src)] = true;
    });
    return (product.images || []).filter(function (src) { return !skip[stripQuery(src)]; }).slice(0, 12);
  }

  function optionNames(product) {
    return (product.options || []).map(function (option) { return typeof option === 'string' ? option : option.name; });
  }

  function optionValues(product, index) {
    var option = (product.options || [])[index];
    if (option && option.values) return option.values;
    var seen = [];
    product.variants.forEach(function (variant) {
      var value = variant.options[index];
      if (seen.indexOf(value) === -1) seen.push(value);
    });
    return seen;
  }

  function findVariant(product, selected) {
    return product.variants.find(function (variant) {
      return variant.options.every(function (value, i) { return value === selected[i]; });
    }) || null;
  }

  // The photo for one option value: the image of a variant with that value, preferring the variant
  // that also matches the shopper's other current choices (same rule as the product page buttons).
  function thumbFor(product, index, value) {
    var best = null;
    product.variants.forEach(function (variant) {
      if (variant.options[index] !== value || !variant.featured_image) return;
      var score = variant.options.reduce(function (sum, option, i) {
        return sum + (i !== index && state.selected[i] === option ? 1 : 0);
      }, 0);
      if (!best || score > best.score) best = { score: score, src: variant.featured_image.src };
    });
    return best ? best.src : '';
  }

  // 2026-10-01 (Todd): shoppers see a short, readable item code instead of the raw supplier SKU (the
  // AliExpress/DSers mapping key, which must not change), and it changes with every variant. Same rule as
  // snippets/sku.liquid: product name, then each option value with generic words dropped, numbers joined to
  // their unit and single letters joined to the word before; e.g. DUNE-4LED-SINGLE-WARM, IRIS-PYRAMID-USBC.
  // If two variants would still match, the variant's position is added.
  var GENERIC = ['light', 'lights', 'color', 'colour', 'colors', 'colours', 'finish', 'version', 'type', 'style', 'the', 'and', 'with', 'of'];
  function handle(text) {
    return String(text || '').toLowerCase().normalize('NFKD').replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9.]+/g, '-').replace(/^-+|-+$/g, '');
  }
  function baseCode(product, variant) {
    var name = String(product.title || '').split(' – ')[0].split(' — ')[0].split(' ')[0];
    var code = handle(name).replace(/[-.]/g, '');
    variant.options.forEach(function (value) {
      if (value === 'Default Title') return;
      var tag = '', num = '';
      handle(value).split('-').forEach(function (w) {
        if (!w || GENERIC.indexOf(w) > -1) return;
        if (/^[\d.]+$/.test(w)) { num += w; return; }
        var part = (num + w).slice(0, 9);
        num = '';
        if (w.length === 1 && tag) tag += w;
        else tag = tag ? tag + '-' + part : part;
      });
      if (num) tag = tag ? tag + '-' + num : num;
      if (tag) code += '-' + tag;
    });
    return code.toUpperCase();
  }
  function itemCode(product, variant) {
    if (!variant) return '';
    var seen = {};
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      var code = baseCode(product, v);
      if (seen[code]) code += '-' + (i + 1);
      seen[code] = true;
      if (v.id === variant.id) return code;
    }
    return baseCode(product, variant);
  }

  function buildDialog() {
    dialog = document.createElement('dialog');
    dialog.className = 'dh-dialog dh-qv';
    dialog.setAttribute('aria-labelledby', 'dh-qv-title');
    dialog.innerHTML =
      '<button type="button" class="dh-dialog-close" data-dh-qv-close aria-label="Close quick view">&times;</button>' +
      '<div class="dh-qv-grid">' +
        '<div class="dh-qv-media">' +
          '<img data-dh-qv-image alt="">' +
          '<div class="dh-card-controls">' +
            '<div class="dh-card-arrows">' +
              '<button type="button" class="dh-card-btn" data-dh-qv-prev aria-label="Previous image">' + ICON_PREV + '</button>' +
              '<button type="button" class="dh-card-btn" data-dh-qv-next aria-label="Next image">' + ICON_NEXT + '</button>' +
            '</div>' +
          '</div>' +
          '<div class="dh-qv-dots" data-dh-qv-dots role="group" aria-label="Product photos"></div>' +
        '</div>' +
        '<div class="dh-qv-body">' +
          '<p class="dh-eyebrow dh-qv-name" data-dh-qv-name hidden></p>' +
          '<h2 class="dh-qv-title" id="dh-qv-title" data-dh-qv-title></h2>' +
          '<p class="dh-qv-price"><span data-dh-qv-price></span><s data-dh-qv-compare></s></p>' +
          '<p class="dh-qv-sku" data-dh-qv-sku-row><span>Item</span><span data-dh-qv-sku></span></p>' +
          '<ul class="dh-qv-highlights" data-dh-qv-highlights aria-label="Highlights" hidden></ul>' +
          '<p class="dh-qv-summary" data-dh-qv-summary hidden></p>' +
          '<div class="dh-qv-options" data-dh-qv-options></div>' +
          '<p class="dh-qv-power" data-dh-qv-power-row hidden style="display:flex;align-items:flex-start;gap:8px;margin:0 0 10px;font-size:12.5px;line-height:1.5;color:var(--dh-cream,#f1e5d6)">' + ICON_PLUG +
            '<span><span style="opacity:.65;letter-spacing:.08em;text-transform:uppercase;font-size:11px;margin-right:6px">Power</span><span data-dh-qv-power></span></span></p>' +
          '<p class="dh-qv-stock" data-dh-qv-stock></p>' +
          '<button type="button" class="dh-button dh-button-gold dh-qv-add" data-dh-qv-add>Add to cart</button>' +
          '<p class="dh-qv-msg" data-dh-qv-msg role="status" aria-live="polite"></p>' +
          '<a class="dh-text-link" data-dh-qv-link href="#">View full details <span aria-hidden="true">&#8599;</span></a>' +
        '</div>' +
      '</div>';
    document.body.appendChild(dialog);

    dialog.addEventListener('click', function (event) {
      var target = event.target instanceof Element ? event.target : null;
      if (!target) return;
      if (target.closest('[data-dh-qv-close]')) { dialog.close(); return; }
      if (target.closest('[data-dh-qv-prev]')) { showImage(state.imageIndex - 1); return; }
      if (target.closest('[data-dh-qv-next]')) { showImage(state.imageIndex + 1); return; }
      var dot = target.closest('[data-dh-qv-dot]');
      if (dot) { showImage(Number(dot.getAttribute('data-dh-qv-dot'))); return; }
      var pill = target.closest('[data-dh-qv-pill]');
      if (pill) {
        state.selected[Number(pill.getAttribute('data-option-index'))] = pill.getAttribute('data-value');
        state.variant = findVariant(state.product, state.selected);
        renderVariant(true);
        return;
      }
      if (target.closest('[data-dh-qv-add]')) { addToCart(); return; }
      if (target === dialog) {
        var r = dialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
      }
    });
    // Swipe between photos on touch screens
    var media = dialog.querySelector('.dh-qv-media');
    var startX = null;
    media.addEventListener('touchstart', function (event) { startX = event.touches[0].clientX; }, { passive: true });
    media.addEventListener('touchend', function (event) {
      if (startX === null || !state) return;
      var dx = event.changedTouches[0].clientX - startX;
      startX = null;
      if (Math.abs(dx) > 40) showImage(state.imageIndex + (dx < 0 ? 1 : -1));
    }, { passive: true });
    dialog.addEventListener('close', function () {
      if (!document.querySelector('dialog.dh-dialog[open]')) document.body.classList.remove('dh-lock');
      if (state && state.trigger && state.trigger.isConnected) state.trigger.focus({ preventScroll: true });
    });
  }

  function part(name) { return dialog.querySelector('[data-dh-qv-' + name + ']'); }

  // Same rule as snippets/dh-product-card.liquid: "Name – Short description" shows the name as the
  // small gold capitals line and the description as the serif title (names of more than 3 words stay whole).
  function splitTitle(title) {
    var seps = [' – ', ' — ', ' - '];
    for (var i = 0; i < seps.length; i++) {
      var at = title.indexOf(seps[i]);
      if (at > 0) {
        var name = title.slice(0, at);
        var desc = title.slice(at + seps[i].length).trim();
        if (name.split(' ').length <= 3 && desc) return [name, desc];
        break;
      }
    }
    return ['', title];
  }

  function showImage(index) {
    var images = state.images;
    var img = part('image');
    var controls = dialog.querySelector('.dh-qv-media .dh-card-controls');
    controls.hidden = images.length < 2;
    if (!images.length) { img.removeAttribute('src'); return; }
    state.imageIndex = (index + images.length) % images.length;
    img.src = sized(images[state.imageIndex], 900);
    img.alt = state.product.title;
    dialog.querySelectorAll('[data-dh-qv-dot]').forEach(function (dot, i) {
      dot.setAttribute('aria-current', String(i === state.imageIndex));
    });
    var next = new Image();
    next.src = sized(images[(state.imageIndex + 1) % images.length], 900);
  }

  function renderDots() {
    var dots = part('dots');
    dots.innerHTML = '';
    if (state.images.length < 2) return;
    state.images.forEach(function (src, i) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'dh-qv-dot';
      dot.setAttribute('data-dh-qv-dot', i);
      dot.setAttribute('aria-label', 'Photo ' + (i + 1) + ' of ' + state.images.length);
      dots.appendChild(dot);
    });
  }

  // A short version of the description: the same bullets the product page shows at the top
  // (the first list in the description, above the FAQ), or its first real sentence or two.
  var FAQ_MARKER = '<h3>Frequently Asked Questions</h3>';
  function renderSummary() {
    var list = part('highlights');
    var summary = part('summary');
    list.innerHTML = '';
    summary.textContent = '';
    var html = String(state.product.description || '').split(FAQ_MARKER)[0];
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var ul = doc.querySelector('ul');
    var items = ul ? [].slice.call(ul.querySelectorAll('li')).map(function (li) {
      return li.textContent.replace(/\s+/g, ' ').trim();
    }).filter(Boolean).slice(0, 4) : [];
    items.forEach(function (text) {
      var li = document.createElement('li');
      li.textContent = text;
      list.appendChild(li);
    });
    list.hidden = !items.length;
    if (!items.length) {
      var para = [].slice.call(doc.querySelectorAll('p')).map(function (p) {
        return p.textContent.replace(/\s+/g, ' ').trim();
      }).find(function (text) { return text.length > 40; });
      if (para) {
        summary.textContent = para.length > 190 ? para.slice(0, 190).replace(/\s+\S*$/, '') + '…' : para;
      }
    }
    summary.hidden = !summary.textContent;
  }

  // 2026-10-01 (Todd): every quick view says whether a wall adapter (plug block) is included. The note comes from
  // product.metafields.custom.power_note, passed on the card's quick view button (data-dh-power); if a card has
  // none, the description's "Power:" line is used instead.
  function renderPower(trigger) {
    var note = (trigger && trigger.getAttribute('data-dh-power')) || '';
    if (!note) {
      var doc = new DOMParser().parseFromString(String(state.product.description || ''), 'text/html');
      var strong = [].slice.call(doc.querySelectorAll('strong')).find(function (s) { return /^\s*power:?\s*$/i.test(s.textContent); });
      if (strong && strong.parentNode) note = strong.parentNode.textContent.replace(/^\s*power:?\s*/i, '').replace(/\s+/g, ' ').trim();
    }
    part('power').textContent = note;
    part('power-row').hidden = !note;
  }

  // 2026-10-01: an option whose every value has its own distinct variant photo (shape, finish, colour)
  // shows that photo on each pill, like the product page buttons. Options without distinct photos
  // (plug type, a single value) stay text-only.
  function renderOptions() {
    var product = state.product;
    var names = optionNames(product);
    var container = part('options');
    container.innerHTML = '';
    var single = product.variants.length === 1 && names.length === 1 && product.variants[0].options[0] === 'Default Title';
    if (single) return;
    names.forEach(function (name, index) {
      var fieldset = document.createElement('fieldset');
      var legend = document.createElement('legend');
      legend.textContent = name;
      var pills = document.createElement('div');
      pills.className = 'dh-qv-pills';
      var values = optionValues(product, index);
      var thumbs = values.map(function (value) { return thumbFor(product, index, value); });
      var distinct = {};
      thumbs.forEach(function (src) { if (src) distinct[stripQuery(src)] = true; });
      var useThumbs = values.length > 1 && thumbs.every(Boolean) && Object.keys(distinct).length === values.length;
      values.forEach(function (value, i) {
        var pill = document.createElement('button');
        pill.type = 'button';
        pill.className = 'dh-qv-pill';
        pill.setAttribute('data-dh-qv-pill', '');
        pill.setAttribute('data-option-index', index);
        pill.setAttribute('data-value', value);
        if (useThumbs) {
          pill.classList.add('dh-has-thumb');
          var thumb = document.createElement('img');
          thumb.className = 'dh-qv-pill-thumb';
          thumb.src = sized(thumbs[i], 120);
          thumb.alt = '';
          thumb.width = 38;
          thumb.height = 38;
          thumb.loading = 'eager';
          pill.appendChild(thumb);
          var label = document.createElement('span');
          label.textContent = value;
          pill.appendChild(label);
        } else {
          pill.textContent = value;
        }
        pills.appendChild(pill);
      });
      fieldset.appendChild(legend);
      fieldset.appendChild(pills);
      container.appendChild(fieldset);
    });
  }

  function renderVariant(jumpToImage) {
    var product = state.product;
    var variant = state.variant;
    dialog.querySelectorAll('[data-dh-qv-pill]').forEach(function (pill) {
      var index = Number(pill.getAttribute('data-option-index'));
      var value = pill.getAttribute('data-value');
      pill.setAttribute('aria-pressed', String(state.selected[index] === value));
      var trial = state.selected.slice();
      trial[index] = value;
      var match = findVariant(product, trial);
      pill.classList.toggle('is-unavailable', !match || !match.available);
    });

    var price = variant ? variant.price : product.price;
    var compare = variant ? variant.compare_at_price : product.compare_at_price;
    part('price').textContent = formatMoney(price);
    part('compare').textContent = compare && compare > price ? formatMoney(compare) : '';
    part('sku').textContent = variant ? itemCode(product, variant) : 'Unavailable combination';
    part('stock').textContent = !variant ? 'Unavailable combination' : variant.available ? 'In stock' : 'Currently sold out';

    var add = part('add');
    add.disabled = !variant || !variant.available;
    add.textContent = !variant ? 'Unavailable' : variant.available ? 'Add to cart' : 'Sold out';
    part('msg').textContent = '';

    var link = part('link');
    link.href = product.url + (variant && product.variants.length > 1 ? '?variant=' + variant.id : '');

    if (jumpToImage && variant && variant.featured_image) {
      var target = stripQuery(variant.featured_image.src);
      var found = state.images.findIndex(function (src) { return stripQuery(src) === target; });
      if (found > -1) showImage(found);
    }
  }

  function openQuickView(trigger) {
    var url = trigger.getAttribute('data-dh-quick-view');
    var variantId = trigger.getAttribute('data-dh-variant');
    if (!dialog) buildDialog();
    trigger.setAttribute('aria-busy', 'true');
    getProduct(url).then(function (product) {
      var variant = null;
      if (variantId) variant = product.variants.find(function (v) { return String(v.id) === variantId; }) || null;
      if (!variant) variant = product.variants.find(function (v) { return v.available; }) || product.variants[0];
      state = {
        product: product,
        variant: variant,
        selected: variant.options.slice(),
        images: quickViewImages(product),
        imageIndex: 0,
        trigger: trigger
      };
      var titleParts = splitTitle(product.title);
      part('name').textContent = titleParts[0];
      part('name').hidden = !titleParts[0];
      part('title').textContent = titleParts[1];
      renderSummary();
      renderOptions();
      renderPower(trigger);
      renderDots();
      showImage(0);
      renderVariant(!!variantId);
      if (!dialog.open) dialog.showModal();
      document.body.classList.add('dh-lock');
    }).catch(function () {
      // If anything goes wrong, fall back to the product page.
      window.location.href = url;
    }).then(function () {
      trigger.removeAttribute('aria-busy');
    });
  }

  // Shopify's asset minifier rewrites import() in this file, so load the theme's
  // @shopify/events module through a small inline module script instead.
  function loadEvents() {
    if (!eventsModule) {
      eventsModule = new Promise(function (resolve) {
        var done = function () { resolve(window.__dhShopifyEvents || null); };
        if (window.__dhShopifyEvents) { done(); return; }
        document.addEventListener('dh:shopify-events', done, { once: true });
        setTimeout(done, 3000);
        var script = document.createElement('script');
        script.type = 'module';
        script.textContent = "import('@shopify/events').then(function (m) { window.__dhShopifyEvents = m; })" +
          ".catch(function () {}).then(function () { document.dispatchEvent(new Event('dh:shopify-events')); });";
        document.head.appendChild(script);
      });
    }
    return eventsModule;
  }

  function fetchCart() {
    return fetch(rootUrl() + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (response) { return response.json(); });
  }

  function addToCart() {
    var variant = state && state.variant;
    if (!variant || !variant.available) return;
    var add = part('add');
    var msg = part('msg');
    add.disabled = true;
    add.textContent = 'Adding…';
    msg.textContent = '';

    var body = new FormData();
    body.append('id', variant.id);
    body.append('quantity', '1');
    var sectionIds = [];
    document.querySelectorAll('cart-items-component').forEach(function (element) {
      if (element.dataset && element.dataset.sectionId) sectionIds.push(element.dataset.sectionId);
    });
    if (sectionIds.length) body.append('sections', sectionIds.join(','));

    loadEvents().then(function (events) {
      // Tell the theme's cart icon and drawer about the add, the same way its own product form does.
      var deferred = events && events.CartLinesUpdateEvent ? events.CartLinesUpdateEvent.createPromise() : null;
      if (deferred) {
        dialog.dispatchEvent(new events.CartLinesUpdateEvent({
          action: 'add',
          context: 'product',
          lines: [{ merchandiseId: String(variant.id), quantity: 1 }],
          promise: deferred.promise
        }));
      }
      return fetch(rootUrl() + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: body,
        credentials: 'same-origin'
      })
        .then(function (response) { return response.json(); })
        .then(function (result) {
          if (result.status) throw new Error(result.description || result.message || 'Could not add to cart');
          return fetchCart().then(function (cart) {
            if (deferred) {
              deferred.resolve({
                cart: events.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
                detail: { items: cart.items, source: 'dh-quick-view', itemCount: 1, productId: String(state.product.id), sections: result.sections, didError: false }
              });
            }
            // The Duskhaven header also refreshes its cart count on this event.
            document.dispatchEvent(new CustomEvent('duskhaven:cart-updated'));
            add.textContent = 'Added';
            msg.innerHTML = 'Added to your cart. <a href="' + rootUrl() + 'cart">View cart</a>';
            setTimeout(function () { if (dialog.open) dialog.close(); }, 900);
          });
        })
        .catch(function (error) {
          if (deferred) deferred.reject(error);
          renderVariant(false);
          msg.textContent = error && error.message ? error.message : 'Something went wrong. Please try again.';
        });
    });
  }

  /* ---------- Wiring ---------- */

  document.addEventListener('click', function (event) {
    var target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    var prev = target.closest('[data-dh-card-prev]');
    var next = target.closest('[data-dh-card-next]');
    var quick = target.closest('[data-dh-quick-view]');
    if (prev) { event.preventDefault(); step(prev, -1); }
    else if (next) { event.preventDefault(); step(next, 1); }
    else if (quick) { event.preventDefault(); openQuickView(quick); }
  });

  function init(root) { bindCards(root); }
  // Cards added later (load more, filters) bind on first contact. Capture phase, so the card's
  // own touch/hover listeners are in place before the event reaches it.
  function lateBind(event) {
    var card = event.target instanceof Element ? event.target.closest('.dh-card') : null;
    if (!card || card.__dhBound || !card.querySelector('[data-dh-card-media]')) return;
    bindCards(card.parentNode || document);
    if (event.type !== 'touchstart') wake(card.querySelector('[data-dh-card-media]'));
  }
  document.addEventListener('pointerover', lateBind, true);
  document.addEventListener('focusin', lateBind, true);
  document.addEventListener('touchstart', lateBind, { capture: true, passive: true });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
